import { LANG } from 'utility/languageUtility';

export default function getPageTitle(_pageTitle, _lang) {
  let fixedTitle = `Province of Manitoba`;
  if (_lang === LANG.FR) fixedTitle = 'Province du Manitoba';

  return `${fixedTitle} | ${_pageTitle}`;
}
